import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlService } from 'app/core/http/url.service';
import { NotificationIds } from 'app/core/notifications/notification-ids.enum';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MinistryFeedbackModel, MinistrySurveyModel, MinistrySurveyRewardModel } from './ministry.model';
import { GameServerGateway } from 'app/student/game-section/services/gateways/game-server-gateway';

@Injectable({
  providedIn: 'root'
})
export class MinistryFeedbackService {

  private readonly rewardSourceId = 'ministry-survey-student-2025';

  constructor(
    private readonly httpClient: HttpClient,
    private readonly urlService: UrlService,
    private readonly gameServerGateway: GameServerGateway
  ) { }

  public getParentSurvey(): Observable<MinistrySurveyModel> {
    const url = this.urlService.buildServerApiUrl('MinistryFeedback', 'Parent');
    return this.httpClient.get<MinistrySurveyModel>(url);
  }

  public getTeacherSurvey(): Observable<MinistrySurveyModel> {
    const url = this.urlService.buildServerApiUrl('MinistryFeedback', 'Teacher');
    return this.httpClient.get<MinistrySurveyModel>(url);
  }

  public getStudentSurvey(): Observable<MinistrySurveyModel> {
    const url = this.urlService.buildServerApiUrl('MinistryFeedback', 'Student');
    return this.httpClient.get<MinistrySurveyModel>(url);
  }

  public getMinistrySurveyRewards(): Observable<MinistrySurveyRewardModel> {
    const url: string = this.urlService.buildGameServerApiUrl('rewards')
    return this.gameServerGateway.get<MinistrySurveyRewardModel>(url, { s : this.rewardSourceId });
  }

  public claimMinistrySurveyReward(): Observable<MinistrySurveyRewardModel> {
    const url: string = this.urlService.buildServerApiUrl('MinistryFeedback', 'Rewards', 'Claim')
    return this.httpClient.post<MinistrySurveyRewardModel>(url, undefined);
  }

  public submitFeedback(feedback: MinistryFeedbackModel): Observable<MinistryFeedbackModel> {
    const url = this.urlService.buildServerApiUrl('MinistryFeedback');
    return this.httpClient.post<MinistryFeedbackModel>(url, feedback);
  }
}
